// appkey定义
const APPKEY = {
  APP: "L7p0aajp4m6bhw9lP7", // app
  SMAPP: "b9E52BA0iV9i42d17c", // 小程序
  SAAS: "saas", // saas
  SAAS1: "000000006",
  SAAS2: "5xW4Gr6v15RGu924Ip",
  CAOCAO: "341803223", // 曹操
  ORANGE: "101437000", // 小桔充电
  OTHER: "other", // 其他
  SAASXB: "000000006", // saas星币
  SAASXC: "5xW4Gr6v15RGu924Ip", // saas星充
};
const APPKEYCONTANT = {
  APP: "L7p0aajp4m6bhw9lP7", // app
  APPLET: "b9E52BA0iV9i42d17c", // 小程序
  SAASXB: "000000006", // saas星币
  SAASXC: "5xW4Gr6v15RGu924Ip", // saas星充
  CAOCAO: "341803223", // 曹操
  ORANGE: "101437000", // 小桔充电
};

const APPKEYOPTIONS = [
  {
    value: "",
    text: "全部",
  },
  {
    value: "L7p0aajp4m6bhw9lP7",
    text: "星星充电-APP",
  },
  {
    value: "5xW4Gr6v15RGu924Ip",
    text: "星星充电-SAAS",
  },
  {
    value: "000000006",
    text: "SAAS-星币账户",
  },
  {
    value: "b9E52BA0iV9i42d17c",
    text: "星星充电-微信",
  },
];

// 表格默认文案设置
const TableLocale = {
  filterTitle: "筛选",
  filterConfirm: "确定",
  filterReset: "重置",
  emptyText: "暂无数据",
};

// 事件监控事件状态
const EVENTSTATUS = [
  {
    value: "",
    text: "全部",
  },
  {
    value: "0",
    text: "待处理",
  },
  {
    value: "1",
    text: "处理中",
  },
  {
    value: "2",
    text: "已处理",
  },
  {
    value: "3",
    text: "已关闭",
  },
];

export { APPKEY, APPKEYOPTIONS, APPKEYCONTANT, TableLocale, EVENTSTATUS };



// WEBPACK FOOTER //
// ./src/AntD/utils/publicParam.js